import React from "react";
import CardHeader from "./CardHeader";
import "../style.scss";
import {
  FlexibleWidthXYPlot,
  XAxis,
  YAxis,
  Hint,
  HorizontalGridLines,
  VerticalBarSeries,
  VerticalBarSeriesCanvas,
  DiscreteColorLegend
} from "react-vis";

const _ = require("lodash");

export default class SummaryGraph extends React.Component {
  state = {
    useCanvas: false
  };
  render() {
    const { user } = this.props;
    const { useCanvas } = this.state;
    const BarSeries = useCanvas ? VerticalBarSeriesCanvas : VerticalBarSeries;

    let activeProgramCount =
      user && user.attributes && user.attributes.activeProgramCount
        ? parseInt(user.attributes.activeProgramCount, 10)
        : 0;

    //activeProgramCount = isNaN(activeProgramCount) ? 0 : activeProgramCount;

    let completeProgramCount =
      user && user.attributes && user.attributes.completeProgramCount
        ? parseInt(user.attributes.completeProgramCount, 10)
        : 0;

    //completeProgramCount = isNaN(completeProgramCount)
    // ? 0
    // : completeProgramCount;

    let conditionData =
      user &&
      user.attributes &&
      user.attributes.conditions &&
      user.attributes.conditions
        .map((condition, index) => {
          return { x: condition.name, y: condition.total };
        })
        .sort((a, b) => {
          return a.y < b.y ? 1 : a.y > b.y ? -1 : 0;
        });

    let labelLength = conditionData && conditionData.length > 5 ? 10 : 15;

    //conditionData = _.slice(conditionData, 7);
    return (
      <div style={{ padding: "15px" }} className="d-flex flex-row flex-fill">
        <div className="flex-fill mr-3">
          <CardHeader title="Conditions" icon="condition" />
          <FlexibleWidthXYPlot
            xType="ordinal"
            stackBy="y"
            height={150}
            onMouseLeave={() => this.setState({ hoverValue: undefined })}
          >
            {this.state.hoverValue ? (
              <Hint value={this.state.hoverValue}>
                <div className="hint shadow-small px-2 py-2">
                  {this.state.hoverValue.x}
                </div>
              </Hint>
            ) : (
              undefined
            )}
            <HorizontalGridLines />
            <XAxis
              tickLabelAngle={0}
              tickFormat={v => {
                return v.length > labelLength
                  ? v.substring(0, labelLength) + "..."
                  : v;
              }}
            />
            <YAxis />
            <BarSeries
              color="#98D5AD"
              data={conditionData}
              onNearestXY={value => this.setState({ hoverValue: value })}
            />
          </FlexibleWidthXYPlot>
        </div>
        <div className="flex-fill mx-3">
          <CardHeader title="Flow" icon="flow" />
          <FlexibleWidthXYPlot xType="ordinal" stackBy="y" height={150}>
            <XAxis />
            <YAxis />
            <BarSeries
              color="#98D5AD"
              data={[
                { x: "Active", y: parseInt(activeProgramCount, 10) },
                {
                  x: "Completed",
                  y: parseInt(completeProgramCount, 10)
                }
              ]}
            />
          </FlexibleWidthXYPlot>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard/SummaryGraph.js